import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { IElementsById } from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import { size } from "polished";
import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Sub from "../../img/icons/sub.svg?react";
import ElementDialogButton from "../ElementDialogButton";
import ElementShirt from "../ElementShirt";
import {
  Controls,
  InfoControl,
  PitchElementWrap,
  PrimaryControl,
  StyledPitchElement,
} from "../Pitch";
import PitchElementData from "../PitchElementData";
import { UnstyledButton } from "../Utils";
import TeamElementIcon from "./TeamElementIcon";

const StyledSub = styled(Sub)`
  ${size(14)}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

const ElementIconWrap = styled.span`
  position: absolute;
  top: 4px;
  right: 2px;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    top: 6px;
    right: 4px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    top: 6px;
    right: 4px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    top: 24%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    top: 27%;
  }
`;

const DreamTeamWrap = styled.div`
  position: absolute;
  top: 22px;
  right: 2px;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    top: 37.5%;
    right: 4px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    top: 44%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    top: 50%;
  }
`;

interface IPropsFromState {
  elementsById: IElementsById;
  rules: IRules | null;
}

interface IPropsFromDispatch {
  showElementDialog: (elementId: number) => void;
}

interface IOwnProps {
  actionMe: () => void;
  chipName: string | null;
  pick: IPickLight;
  renderDreamTeam: (pick: IPickLight) => React.ReactNode;
  renderElementMenu: () => void;
  renderPickValue: (pick: IPickLight) => React.ReactNode;
}

type Props = IPropsFromState & IPropsFromDispatch & IOwnProps;

const TeamPitchElement: React.FC<Props> = ({
  actionMe,
  chipName,
  pick,
  elementsById,
  renderElementMenu,
  renderPickValue,
  renderDreamTeam,
  rules,
}) => {
  if (!rules) return null;

  const element = elementsById[pick.element];

  return (
    <PitchElementWrap variant={pick.subStatus || ""}>
      <StyledPitchElement>
        <UnstyledButton type="button" onClick={renderElementMenu}>
          <ElementShirt
            elementId={element.id}
            sizes="(min-width: 1024px) 115px, (min-width: 610px) 90px, 50px"
          />
          <PitchElementData element={element} value={renderPickValue(pick)} />
        </UnstyledButton>
        <Controls>
          {actionMe && typeof pick.subStatus !== "undefined" && (
            <PrimaryControl>
              <UnstyledButton type="button" onClick={actionMe}>
                <StyledSub />
              </UnstyledButton>
            </PrimaryControl>
          )}
          <InfoControl>
            <ElementDialogButton elementId={pick.element} />
          </InfoControl>
        </Controls>

        <ElementIconWrap>
          <TeamElementIcon pick={pick} chipName={chipName} />
        </ElementIconWrap>

        <DreamTeamWrap>{renderDreamTeam(pick)}</DreamTeamWrap>
      </StyledPitchElement>
    </PitchElementWrap>
  );
};

const mapStateToProps = (state: RootState): IPropsFromState => ({
  elementsById: getElementsById(state),
  rules: getRules(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch): IPropsFromDispatch => ({
  showElementDialog: (elementId) => dispatch(showElementSummary(elementId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamPitchElement);
